/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { inject, Injectable } from '@angular/core';
import { DatabaseHelper } from './database-helper';
import { DBCreator } from './interface/dbcreator';
import { AppConfig } from '../app-config';
import { BehaviorSubject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  private config = inject(AppConfig);

  static readonly CACHE_STORE = 'inf-cache';

  public version;
  public storeName;
  public dbPointer;
  public db: IDBDatabase;
  public helper: DatabaseHelper;
  public error: any;
  public onInit = new BehaviorSubject<DatabaseHelper>(null);

  /**
   * Init the service an create structure of database
   * Must be call on the appModule
   * @param creator
   */
  public init(creator: DBCreator) {
    if ((!(navigator.appName === 'Microsoft Internet Explorer')
      && !(/Edge\/\d./i.test(navigator.userAgent))) && !(/Trident\/\d./i.test(navigator.userAgent))) {
      this.storeName = this.config.appName;
      this.version = this.config.db.version;
      this.dbPointer = indexedDB.open(this.storeName, this.version);
      this.dbPointer.onupgradeneeded = (event) => {
        creator.onUpgrade(this.dbPointer.result, event.oldVersion, event.newVersion);
        const db = this.dbPointer.result;
        if (this.config.cache) {
          if (!db.objectStoreNames || !db.objectStoreNames.contains(DatabaseService.CACHE_STORE)) {
            const store = db.createObjectStore(DatabaseService.CACHE_STORE, {keyPath: ['url', 'token', 'method']});
            store.createIndex('validity', 'stamp');
          }
        }
      };
      this.dbPointer.onsuccess = () => {
        this.db = this.dbPointer.result;
        this.helper = new DatabaseHelper(this.db, this.storeName);
        this.onInit.next(this.helper);
      };
      this.dbPointer.onerror = (error: any) => {
        console.error('Impossible to load database-service, the application will run with no cache');
        this.error = error;
        this.config.cache = 0;
      };
    } else {
      this.config.cache = 0;
    }
  }

  /**
   * return observable who's emit when databaseHelper is instanced
   * @param success
   * @param error
   */
  public getDataBaseHelper(success: (helper: DatabaseHelper) => void, error?: (error: any) => void) {
    this.checkHelper({success: success, error: error}, 0);
  }

  /**
   * Check the existence of helper
   * @param handler
   * @param count
   */
  private checkHelper(handler: {success: (helper: DatabaseHelper) => void, error?: (error: any) => void}, count: number) {
    if (this.helper) {
      handler.success(this.helper);
    } else {
        setTimeout((args) => {
          if (args.count < 3) {
            this.checkHelper(args.handler, args.count);
          } else {
            args.handler.error('Impossible to load db');
          }
      }, 200, {count: count + 1, handler: handler});
    }
  }


  subscribe(next?: (value: DatabaseHelper) => void, error?: (error: any) => void, complete?: () => void): Subscription {
    return this.onInit.subscribe(next, error, complete);
  }
}
